var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "accountsPayableManagement-app-container",
      staticStyle: { position: "relative", height: "100%", padding: "10px" },
    },
    [
      _c(
        "el-dialog",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dialogNoteLoading,
              expression: "dialogNoteLoading",
            },
          ],
          attrs: {
            "append-to-body": "",
            "modal-append-to-body": "",
            top: _vm.dialogTopMargin,
            title: _vm.currentTravelName + " 旅客使用紀錄",
            visible: _vm.travelersDetailsDialogNoteVisible,
            width: "60%",
          },
          on: {
            closed: function ($event) {
              _vm.currentTravelID = null
            },
            "update:visible": function ($event) {
              _vm.travelersDetailsDialogNoteVisible = $event
            },
          },
        },
        [
          _c("TravelersUsed", {
            attrs: {
              travelID: _vm.currentTravelID,
              travelName: _vm.currentTravelName,
            },
          }),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "danger" },
                  on: {
                    click: function ($event) {
                      _vm.travelersDetailsDialogNoteVisible = false
                    },
                  },
                },
                [_vm._v("關 閉")]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.currentAgencyReceivableListRow
        ? _c(
            "el-dialog",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.dialogNoteLoading,
                  expression: "dialogNoteLoading",
                },
              ],
              attrs: {
                top: _vm.dialogTopMargin,
                title:
                  _vm.currentAgencyReceivableListRow.agencyName + "備註管理",
                visible: _vm.dialogNoteVisible,
                width: "60%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogNoteVisible = $event
                },
                closed: _vm.onNoteDialogClosed,
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("el-card", { staticClass: "box-card" }, [
                        _c(
                          "div",
                          {
                            staticClass: "clearfix",
                            attrs: { slot: "header" },
                            slot: "header",
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "17px",
                                  "user-select": "auto",
                                  color: "blue",
                                  "font-weight": "bold",
                                },
                              },
                              [_vm._v("備註管理")]
                            ),
                          ]
                        ),
                        _c(
                          "div",
                          [
                            _c("tinymce", {
                              ref: "tinymce",
                              attrs: { height: 300, type: 27 },
                              model: {
                                value:
                                  _vm.currentAgencyReceivableListRow.note
                                    .content,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.currentAgencyReceivableListRow.note,
                                    "content",
                                    $$v
                                  )
                                },
                                expression:
                                  "currentAgencyReceivableListRow.note.content",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "success" },
                      on: { click: _vm.savePaymentInvoiceNote },
                    },
                    [_vm._v("儲 存")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "danger" },
                      on: {
                        click: function ($event) {
                          _vm.dialogNoteVisible = false
                        },
                      },
                    },
                    [_vm._v("關 閉")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.currentAgencyReceivableListRow &&
      _vm.currentAgencyReceivableListRow.invoiceInfo
        ? _c(
            "el-dialog",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.dialogFileLoading,
                  expression: "dialogFileLoading",
                },
              ],
              attrs: {
                top: _vm.dialogTopMargin,
                title: "檔案上傳",
                visible: _vm.dialogFileVisible,
                width: "50%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogFileVisible = $event
                },
                close: _vm.onDialogClosed,
              },
            },
            [
              _c(
                "el-row",
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-card", { staticClass: "box-card" }, [
                        _c(
                          "div",
                          {
                            staticClass: "clearfix",
                            attrs: { slot: "header" },
                            slot: "header",
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "17px",
                                  "user-select": "auto",
                                  color: "blue",
                                  "font-weight": "bold",
                                },
                              },
                              [_vm._v("請款單")]
                            ),
                            _c(
                              "div",
                              { staticStyle: { float: "right" } },
                              [
                                _c("Upload", {
                                  ref: "uploadRef1",
                                  attrs: {
                                    payload:
                                      _vm.currentAgencyReceivableListRow
                                        .invoiceInfo,
                                    "data-obj": _vm.fileObj,
                                    "limit-file-count": 10,
                                    "use-drag": false,
                                    action: "Agency/saveFile",
                                    "auto-upload": false,
                                    "show-file-list": true,
                                    "btn-txt": "選擇檔案",
                                    "before-file-list": _vm.formData.file1,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("el-card", { staticClass: "box-card" }, [
                        _c(
                          "div",
                          {
                            staticClass: "clearfix",
                            attrs: { slot: "header" },
                            slot: "header",
                          },
                          [
                            _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "17px",
                                  "user-select": "auto",
                                  color: "blue",
                                  "font-weight": "bold",
                                },
                              },
                              [_vm._v(" 發票")]
                            ),
                            _c(
                              "div",
                              { staticStyle: { float: "right" } },
                              [
                                _c("Upload", {
                                  ref: "uploadRef2",
                                  attrs: {
                                    payload: _vm.formData,
                                    "data-obj": _vm.fileObj,
                                    "limit-file-count": 10,
                                    "use-drag": false,
                                    action: "Agency/saveFile",
                                    "auto-upload": false,
                                    "show-file-list": true,
                                    "btn-txt": "選擇檔案",
                                    "before-file-list": _vm.formData.file2,
                                  },
                                }),
                              ],
                              1
                            ),
                          ]
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "success" },
                      on: { click: _vm.saveData },
                    },
                    [_vm._v("儲 存")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { size: "mini", type: "danger" },
                      on: {
                        click: function ($event) {
                          _vm.dialogFileVisible = false
                        },
                      },
                    },
                    [_vm._v("關 閉")]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm.currentAgencyReceivableListRow &&
      _vm.currentAgencyReceivableListRow.invoiceInfo
        ? _c(
            "el-dialog",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.dialogFileLoading,
                  expression: "dialogFileLoading",
                },
              ],
              attrs: {
                fullscreen: true,
                top: _vm.dialogTopMargin,
                title:
                  _vm.currentAgencyReceivableListRow.agencyName +
                  " 統計區間：" +
                  _vm.currentAgencyReceivableListRow.invoiceInfo.dateRangeInfo +
                  " 總金額：" +
                  _vm.currentAgencyReceivableListRow.pricing.totalPriceTaxStr,
                visible: _vm.dialogVisible,
                width: "80%",
              },
              on: {
                "update:visible": function ($event) {
                  _vm.dialogVisible = $event
                },
              },
            },
            [
              _c(
                "div",
                { staticStyle: { position: "relative", height: "100%" } },
                [
                  _c(
                    "el-table",
                    {
                      directives: [
                        {
                          name: "loading",
                          rawName: "v-loading",
                          value: _vm.listLoading,
                          expression: "listLoading",
                        },
                      ],
                      attrs: {
                        size: "mini",
                        data: _vm.currentAgencyReceivableListRow.invoiceInfo
                          .data,
                        border: "",
                        fit: "",
                        "highlight-current-row": "",
                        height: "100%",
                      },
                    },
                    [
                      _c("el-table-column", {
                        attrs: { align: "center", label: "項次", width: "60" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.$index + 1)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          4178052834
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "left",
                          label: "總金額(含稅)",
                          width: "130",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.pricing
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-size": "15px",
                                            color: "#1890ff",
                                            "font-weight": "bold",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.pricing.totalPriceTaxStr
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3741328113
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "left",
                          label: "App金額(含稅)",
                          width: "130",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.pricing
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-size": "15px",
                                            color: "#1890ff",
                                            "font-weight": "bold",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.pricing
                                                .appUseTotalPriceTaxStr
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          8933939
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "left",
                          label: "App金額(未稅)",
                          width: "130",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.pricing
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-size": "15px",
                                            color: "#1890ff",
                                            "font-weight": "bold",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.pricing
                                                .appUseTotalPriceStr
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1431290174
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "left",
                          label: "App金額(稅金)",
                          width: "150",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.pricing
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-size": "15px",
                                            color: "green",
                                            "font-weight": "bold",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.pricing
                                                .appUseTotalTaxStr
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3458343750
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "left",
                          label: "網卡金額(含稅)",
                          width: "130",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.pricing
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-size": "15px",
                                            color: "#1890ff",
                                            "font-weight": "bold",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.pricing
                                                .networkCardUseTotalPriceTaxStr
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2615630488
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "left",
                          label: "網卡金額(未稅)",
                          width: "130",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.pricing
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-size": "15px",
                                            color: "#1890ff",
                                            "font-weight": "bold",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.pricing
                                                .networkCardUseTotalPriceStr
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1663763861
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "left",
                          label: "網卡金額(稅金)",
                          width: "150",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.pricing
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-size": "15px",
                                            color: "green",
                                            "font-weight": "bold",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.pricing
                                                .networkCardTotalTaxStr
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2803791854
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "left",
                          label: "網卡運費(含稅)",
                          width: "150",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.pricing
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-size": "15px",
                                            color: "#1890ff",
                                            "font-weight": "bold",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.pricing
                                                .networkCardPostFeePriceTaxStr
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1990981191
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "left",
                          label: "網卡運費(未稅)",
                          width: "150",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.pricing
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-size": "15px",
                                            color: "#1890ff",
                                            "font-weight": "bold",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.pricing
                                                .networkCardPostFeePriceStr
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1341073514
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "left",
                          label: "網卡運費(稅金)",
                          width: "150",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  scope.row.pricing
                                    ? _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "font-size": "15px",
                                            color: "green",
                                            "font-weight": "bold",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              scope.row.pricing
                                                .networkCardPostFeeTaxStr
                                            )
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3961352338
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "團號", width: "150" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.tourGroupNo)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3866911428
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "出團日",
                          width: "110",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.beginDate)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2549305237
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "結束日",
                          width: "110",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c("span", [
                                    _vm._v(_vm._s(scope.row.endDate)),
                                  ]),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1215041949
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "團名", width: "350" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (ref) {
                                var row = ref.row
                                return [
                                  _c("span", [_vm._v(_vm._s(row.travelName))]),
                                  _c(
                                    "div",
                                    [
                                      _c("el-tag", [
                                        _vm._v(
                                          " 出發" +
                                            _vm._s(
                                              row.beginDate +
                                                " " +
                                                row.beginTime
                                            ) +
                                            " - 回程" +
                                            _vm._s(
                                              row.endDate + " " + row.endTime
                                            ) +
                                            " "
                                        ),
                                      ]),
                                    ],
                                    1
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1471787505
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "狀態", width: "110" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-tag",
                                    {
                                      attrs: {
                                        type: _vm.statusTranslateStyle(
                                          scope.row.status
                                        ),
                                      },
                                    },
                                    [_vm._v(_vm._s(scope.row.statusDesc))]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          488953597
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: { align: "center", label: "天數", width: "80" },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "span",
                                    { staticStyle: { "font-size": "17px" } },
                                    [_vm._v(_vm._s(scope.row.totalday))]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          1101603726
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "旅客數",
                          width: "80",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "span",
                                    { staticStyle: { "font-size": "17px" } },
                                    [_vm._v(_vm._s(scope.row.tourist))]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          2594236738
                        ),
                      }),
                      _c(
                        "el-table-column",
                        {
                          attrs: {
                            align: "center",
                            label: "基本單價",
                            width: "80",
                          },
                        },
                        [
                          [
                            _c(
                              "span",
                              { staticStyle: { "font-size": "17px" } },
                              [_vm._v(_vm._s(20))]
                            ),
                          ],
                        ],
                        2
                      ),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "網卡數量",
                          width: "80",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return scope.row.networkCardSouece
                                  ? [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { "font-size": "17px" },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(scope.row.networkCardCount)
                                          ),
                                        ]
                                      ),
                                    ]
                                  : undefined
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "網卡項目單價",
                          width: "180",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return scope.row.networkCardSouece
                                  ? [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            scope.row.networkCardSouece
                                              .cardName +
                                              " ，$" +
                                              scope.row.networkCardSouece.price
                                          )
                                        ),
                                      ]),
                                    ]
                                  : undefined
                              },
                            },
                          ],
                          null,
                          true
                        ),
                      }),
                      _c("el-table-column", {
                        attrs: {
                          align: "center",
                          label: "使用旅客名單",
                          width: "160",
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "default",
                              fn: function (scope) {
                                return [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: { type: "success" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.getTravelersDetails(
                                            scope.row
                                          )
                                        },
                                      },
                                    },
                                    [_vm._v("使用旅客名單")]
                                  ),
                                ]
                              },
                            },
                          ],
                          null,
                          false,
                          3306797940
                        ),
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "span",
                {
                  staticClass: "dialog-footer",
                  attrs: { slot: "footer" },
                  slot: "footer",
                },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "danger" },
                      on: {
                        click: function ($event) {
                          _vm.dialogVisible = false
                        },
                      },
                    },
                    [_vm._v("關 閉")]
                  ),
                ],
                1
              ),
            ]
          )
        : _vm._e(),
      _c(
        "div",
        { staticStyle: { padding: "20px", "padding-bottom": "0" } },
        [
          _c(
            "el-form",
            { attrs: { inline: true } },
            [
              _c(
                "el-form-item",
                { attrs: { label: "旅行社" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        filterable: "",
                        placeholder: "請選擇旅行社",
                        clearable: "",
                      },
                      model: {
                        value: _vm.listQuery.agencyCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.listQuery, "agencyCode", $$v)
                        },
                        expression: "listQuery.agencyCode",
                      },
                    },
                    _vm._l(_vm.agencyList, function (item) {
                      return _c("el-option", {
                        key: item.key,
                        attrs: { label: item.val, value: item.key },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-form-item",
                { attrs: { label: "回程區間" } },
                [
                  _c("el-date-picker", {
                    attrs: {
                      type: "daterange",
                      align: "right",
                      "unlink-panels": "",
                      "range-separator": "至",
                      "start-placeholder": "開始日期",
                      "end-placeholder": "結束日期",
                      "value-format": "yyyy-MM-dd",
                    },
                    model: {
                      value: _vm.listQuery.dateFilter,
                      callback: function ($$v) {
                        _vm.$set(_vm.listQuery, "dateFilter", $$v)
                      },
                      expression: "listQuery.dateFilter",
                    },
                  }),
                ],
                1
              ),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    { attrs: { type: "primary" }, on: { click: _vm.getList } },
                    [_vm._v("查詢")]
                  ),
                ],
                1
              ),
              _vm.list && _vm.list.length > 0
                ? _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "warning", icon: "el-icon-download" },
                          on: { click: _vm.exportExcel },
                        },
                        [_vm._v("下載Excel")]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-alert",
                    {
                      staticStyle: { margin: "3px" },
                      attrs: {
                        type: "success",
                        effect: "dark",
                        closable: false,
                      },
                    },
                    [
                      _c("template", { slot: "title" }, [
                        _vm._v(
                          " 計算區間：例.2022-09-26-2022-10-25，以行程結束日於此區間內做為呈現。 "
                        ),
                      ]),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { position: "relative", height: "80%" } },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              attrs: {
                size: "mini",
                data: _vm.list,
                border: "",
                fit: "",
                "highlight-current-row": "",
                height: "100%",
                "cell-style": _vm.cellStyle,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "項次",
                  width: "60",
                  fixed: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.$index + 1))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  label: "統編",
                  width: "120",
                  fixed: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "15px",
                              color: "#1890ff",
                              "font-weight": "bold",
                            },
                          },
                          [_vm._v(_vm._s(scope.row.vatNumber))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  label: "旅行社名稱",
                  width: "200",
                  fixed: "",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              "font-size": "15px",
                              color: "#1890ff",
                              "font-weight": "bold",
                            },
                          },
                          [_vm._v(_vm._s(scope.row.agencyName))]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "總金額(含稅)", width: "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.pricing
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "15px",
                                  color: "#1890ff",
                                  "font-weight": "bold",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(scope.row.pricing.totalPriceTaxStr)
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "App金額(含稅)", width: "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.pricing
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "15px",
                                  color: "#1890ff",
                                  "font-weight": "bold",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    scope.row.pricing.appUseTotalPriceTaxStr
                                  )
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "App金額(未稅)", width: "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.pricing
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "15px",
                                  color: "#1890ff",
                                  "font-weight": "bold",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(scope.row.pricing.appUseTotalPriceStr)
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "App金額(稅金)", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.pricing
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "15px",
                                  color: "green",
                                  "font-weight": "bold",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(scope.row.pricing.appUseTotalTaxStr)
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "網卡金額(含稅)", width: "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.pricing
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "15px",
                                  color: "#1890ff",
                                  "font-weight": "bold",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    scope.row.pricing
                                      .networkCardUseTotalPriceTaxStr
                                  )
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "網卡金額(未稅)", width: "130" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.pricing
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "15px",
                                  color: "#1890ff",
                                  "font-weight": "bold",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    scope.row.pricing
                                      .networkCardUseTotalPriceStr
                                  )
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "網卡金額(稅金)", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.pricing
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "15px",
                                  color: "green",
                                  "font-weight": "bold",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    scope.row.pricing.networkCardTotalTaxStr
                                  )
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "網卡運費(含稅)", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.pricing
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "15px",
                                  color: "#1890ff",
                                  "font-weight": "bold",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    scope.row.pricing
                                      .networkCardPostFeePriceTaxStr
                                  )
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "網卡運費(未稅)", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.pricing
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "15px",
                                  color: "#1890ff",
                                  "font-weight": "bold",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    scope.row.pricing.networkCardPostFeePriceStr
                                  )
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "網卡運費(稅金)", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.pricing
                          ? _c(
                              "span",
                              {
                                staticStyle: {
                                  "font-size": "15px",
                                  color: "green",
                                  "font-weight": "bold",
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    scope.row.pricing.networkCardPostFeeTaxStr
                                  )
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "電話", width: "150" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.tel))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "負責人", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_c("span", [_vm._v(_vm._s(scope.row.boss))])]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "付款日", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.paymentDate))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "結帳日", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.checkOutDate))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "left", label: "旅行社代碼", width: "190" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("span", [_vm._v(_vm._s(scope.row.agencyCode))]),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  label: "管理",
                  width: "300",
                  fixed: "right",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              disabled: scope.row.invoiceInfo.data == null,
                              type: "success",
                              size: "mini",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.getAgencyReceivableList(scope.row)
                              },
                            },
                          },
                          [_vm._v("查看")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.openFileDialog(scope.row)
                              },
                            },
                          },
                          [_vm._v("單據管理")]
                        ),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "success", size: "mini" },
                            on: {
                              click: function ($event) {
                                return _vm.openNoteDialog(scope.row)
                              },
                            },
                          },
                          [_vm._v("備註管理")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("pagination", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.total > 0,
            expression: "total > 0",
          },
        ],
        staticStyle: { "padding-top": "0" },
        attrs: {
          layout: "prev, pager, next",
          total: _vm.total,
          page: _vm.listQuery.page,
          limit: _vm.listQuery.limit,
        },
        on: {
          "update:page": function ($event) {
            return _vm.$set(_vm.listQuery, "page", $event)
          },
          "update:limit": function ($event) {
            return _vm.$set(_vm.listQuery, "limit", $event)
          },
          pagination: _vm.getList,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }